import Box from 'UIKit/Box/Box'
import Skeleton from 'UIKit/Skeleton'
import { TableRowValueHistory } from 'UIKit/Table/TableHistory'
import TokenLogo from 'UIKit/TokenLogo'
import configTokens from 'config/constants/tokens'
import { DepositBonus } from 'config/types/bonus/userBonus'
import { Transaction } from 'config/types/transaction'
import useModal from 'hooks/useModal'
import Column from 'layout/Components/Column'
import { RowBetween, RowMiddle } from 'layout/Components/Row'
import { Icons } from 'svgs'
import theme from 'theme'
import { getTokenName } from 'utils/token'
import BonusDetailsModal from 'views/BonusCenter/components/BonusDetailsModal'
import { RowDisplayCurrencyAmountSymbolItem, TransactionDate, TransactionStatus, WrapperRowHistory } from '../styled'
import DepositTransactionDetailsModal from './DepositTransactionDetailsModal'

export const DepositTransactionListLoader = () => {
  return (
    <WrapperRowHistory>
      <RowBetween>
        <RowMiddle>
          <Skeleton width={32} height={32} borderRadius="50% !important" />
          <Column ml="12px">
            <Skeleton width={80} minHeight="18px !important" height="18px" mb="6px" />
            <Skeleton width={120} minHeight="16px !important" height="16px" />
          </Column>
        </RowMiddle>

        <Column alignItems="flex-end">
          <Skeleton width={120} minHeight="18px !important" height="18px" mb="6px" />
          <Skeleton width={60} minHeight="16px !important" height="16px" />
        </Column>
      </RowBetween>
    </WrapperRowHistory>
  )
}

const DepositTransactionListITem: React.FC<{
  transaction: { item: Transaction; bonusInfo: DepositBonus }
}> = ({ transaction }) => {
  const { item, bonusInfo } = transaction

  const token = configTokens[item.network]?.[item.currency]

  const [onPresent] = useModal(DepositTransactionDetailsModal)
  const [onPresentBonusDetail] = useModal(BonusDetailsModal)

  return (
    <WrapperRowHistory
      onClick={() => {
        onPresent({
          transaction: item,
          bonusInfo,
        })
      }}
    >
      <RowBetween>
        <RowMiddle>
          <Box minWidth="32px">
            <TokenLogo token={token} size={32} networkImageProps={{ width: 16, height: 16 }} />
          </Box>

          <Column justifyContent="flex-start" ml="12px">
            <TableRowValueHistory
              color={`var(--pm-history-title, ${theme.colors.textTertiary})`}
              fontWeight={600}
              as="span"
            >
              {getTokenName(token)}
            </TableRowValueHistory>
            <TransactionDate
              fontSize="12px"
              lineHeight="20px"
              date={item.createTime}
              color={`var(--pm-history-note, ${theme.colors.textAlt1})`}
              textAlign="left"
              width="max-content"
            />
          </Column>
        </RowMiddle>
        <Column alignItems="flex-end">
          <RowMiddle
            justifyContent="flex-end"
            style={{
              textAlign: 'right',
            }}
          >
            {bonusInfo && (
              <RowMiddle
                height="20px"
                mr="4px"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  onPresentBonusDetail({ bonus: bonusInfo })
                }}
              >
                <Icons.GiftOutLineIcon />
              </RowMiddle>
            )}
            <RowDisplayCurrencyAmountSymbolItem
              color={`var(--pm-history-amount, ${theme.colors.textTertiary})`}
              token={token}
              value={item.value}
              hideLogo
            />
          </RowMiddle>
          <Column>
            <TransactionStatus lineHeight="20px" status={item.status} />
          </Column>
        </Column>
      </RowBetween>
    </WrapperRowHistory>
  )
}

export default DepositTransactionListITem
